import { CartState } from '@nrdy-marketing-engine/cart/@types/cart-state';
import { RefObject, useCallback } from 'react';
import { FieldErrors, SubmitErrorHandler } from 'react-hook-form';

const OFFSET = 80;

/**
 * React hook to scroll to the first error in the form. Best used with handleSubmit from useForm.
 */
function useScrollToError(container: RefObject<HTMLDivElement>): SubmitErrorHandler<CartState> {
  return useCallback(
    (errors: FieldErrors<CartState>) => {
      // find first error within the container and scroll up to it
      for (const key of Object.keys(errors)) {
        const ref = errors[key].ref;
        const el = ref && container.current.querySelector(`[name="${errors[key].ref.name}"]`);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - OFFSET;
          window.scrollTo({ top: y, behavior: 'smooth' });
          return;
        }
      }
    },
    [container]
  );
}

export default useScrollToError;
